<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Options-->
<div class="MainGrid2Col">
	<label>Trigger:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstTriggers"
		[(ngModel)]="SelectedTrigger"
		optionLabel="PointsAutomatedItemTypeDesc"
		[filter]="true"
		filterBy="PointsAutomatedItemTypeDesc"
		[showClear]="false"
		placeholder="Select a Trigger"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedTrigger">
				<div class="form-control NoBorder" style="text-align: left">
					{{ SelectedTrigger.PointsAutomatedItemTypeDesc }}
				</div>
			</div>
		</ng-template>
		<ng-template let-TriggerItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ TriggerItem.PointsAutomatedItemTypeDesc }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>

	<label>Point:</label>
	<p-dropdown
		style="margin-left: 5px"
		[disabled]="IsLoading() == true"
		[options]="lstPBIS"
		[(ngModel)]="SelectedPBIS"
		optionLabel="PointsItemDesc"
		[filter]="true"
		filterBy="PointsItemDesc"
		[showClear]="false"
		placeholder="Select a Point"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedPBIS">
				<div class="form-control NoBorder" style="text-align: left">
					{{ SelectedPBIS.PointsItemDesc }}
				</div>
			</div>
		</ng-template>
		<ng-template let-PBISItem pTemplate="item">
			<div>
				<div class="form-control NoBorder" style="text-align: left">
					{{ PBISItem.PointsItemDesc }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>

<!--Schools -->
<div class="SchoolBorder">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School" (dblclick)="onRowDblClick(School)">
				<td>
					<p-tableCheckbox [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ School[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="EditMode == false" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
